<template>
    <span class="i-layout-menu-side-title" :class="{ 'i-layout-menu-side-title-with-collapse': collapse }">
        <template v-if="type === 'back'">
            <Icon type="ios-arrow-back"/>
        </template>
        <template v-else>
            <span class="i-layout-menu-side-title-icon" :class="{ 'i-layout-menu-side-title-icon-single': hideTitle }"
                v-if="withIcon">
                <Icon :type="menu.icon" v-if="menu.icon" />
                <Icon :custom="menu.custom" v-else-if="menu.custom" />
                <img :src="menu.img" v-else-if="menu.img" />
            </span>
            <span v-else>
                &nbsp;&nbsp; &nbsp;
            </span>
        </template>
        <span
            class="i-layout-menu-side-title-text"
            :class="{ 'i-layout-menu-side-title-text-selected': selected, 'i-layout-menu-side-title-text-with-subtitle': menu.subtitle, 'i-layout-menu-side-title-text-with-icon': withIcon }"
            v-if="!hideTitle">
            {{ tTitle(menu.title) }}
            <em v-if="menu.subtitle">{{ tTitle(menu.subtitle) }}</em>
        </span>
        <Icon type="ios-arrow-forward" v-if="menu.children !== undefined && menu.children.length>0 && !type"/>
    </span>
</template>
<script>
import tTitle from '../mixins/translate-title';

export default {
    name: 'iMenuSideTitle',
    mixins: [tTitle],
    props: {
        menu: {
            type: Object,
            default() {
                return {}
            }
        },
        hideTitle: {
            type: Boolean,
            default: false
        },
        // 用于侧边栏收起 Dropdown 当前高亮
        selected: {
            type: Boolean,
            default: false
        },
        // 侧边栏折叠状态
        collapse: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: null
         }
    },
    computed: {
        withIcon() {
            return this.menu.icon || this.menu.custom || this.menu.img;
        }
    }
}
</script>
